import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Thibodaux, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Thibodaux can take 2–6 months, especially during busy travel seasons. For offshore oil workers, Nicholls State travelers, and Lafourche Parish families, that timeline is simply not viable.",
  },
  {
    q: "Can offshore workers in Thibodaux get an expedited passport quickly?",
    a: "Absolutely. Offshore oil and gas workers are one of our most common client types in Thibodaux and the bayou region. Rig rotations often change with little notice, and international assignments to West Africa, the North Sea, or Brazil require valid passports. We regularly process expedited renewals and new applications for offshore workers on compressed timelines. Contact us as soon as your rotation schedule is confirmed.",
  },
  {
    q: "What if my passport expires before a Nicholls State study abroad semester?",
    a: "This happens more often than you would think — especially for Nicholls State University students who confirm study abroad placements with limited lead time. Most international programs require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Thibodaux post office typically takes 2–6 months — far too long for a semester starting next month.",
  },
  {
    q: "Can families in Houma and Schriever get expedited passports?",
    a: "Yes. Families throughout Lafourche and Terrebonne Parishes have the same access to our expedited services as Thibodaux residents. Since we operate remotely, your physical location in the bayou region does not affect processing speed. Ship your documents overnight from anywhere in the area, and we handle the rest. Most clients in the Thibodaux-Houma region receive their passports within 2–9 business days.",
  },
  {
    q: "How quickly can travelers in Raceland and Cut Off receive an expedited passport?",
    a: "Raceland, Cut Off, and surrounding bayou communities have the same access to our expedited services as Thibodaux residents. Since we operate remotely, your physical location in Lafourche Parish does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the bayou region receive their passports within 2–9 business days.",
  },
  {
    q: "Can sugarcane industry executives expedite a passport renewal?",
    a: "Yes — sugarcane industry professionals, agricultural researchers, and agribusiness executives from Thibodaux and throughout Lafourche Parish are well within our service area. Whether you are traveling to Brazil for an industry conference, visiting sugar operations in Australia, or attending an agricultural trade show in Europe, we make the renewal process straightforward. You do not need to drive 60 miles to New Orleans for a passport agency appointment.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Thibodaux travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Thibodaux, but that is the point: you do not need one — and you definitely do not need to drive 60 miles to New Orleans. Start your order online, follow the checklist, and ship your documents overnight from anywhere in Lafourche Parish or the bayou region.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function ThibodauxFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Thibodaux and Lafourche Parish travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}